export default __webpack_public_path__ + "static/alert-706e1d4cb2a7e8322142a35ba3880952.mp3";